export default "__VITE_ASSET__CaM30KUq__"